import * as R from 'ramda';

export default function DashboardSummaryController(
  $q,
  $sce,
  $rootScope,
  $scope,
  $timeout,
  $http,
  userService,
  alerts,
  ssDialogService,
  dashBoardDetailDialog,
  reportsDataService,
  loaderService
) {
  const vm = this;

  vm.appIsLoaded = true;
  vm.controls = [];
  vm.handleClick = handleClick;
  vm.iframeMouseOver = false;
  vm.showAll = false;
  vm.currentWidget = null;
  vm.handleShowDetailClick = _handleShowDetailClick;

  _activate();

  function handleClick() {
    R.forEach((item) => {
      item.show = true;
      item.flex = 30;
    }, vm.widgets);
    vm.showAll = false;
  }

  function _activate() {
    // eslint-disable-next-line no-useless-concat
    vm.showing = false;
    reportsDataService.getAllWidgetsHtml().then((response) => {
      vm.allwidgets = [];
      vm.allwidgetsHtml = [];
      vm.allwidgets = response.data[0].widgets;
      vm.batchCount = 5;
      if (vm.allwidgets && vm.allwidgets.length > 0) {
        sendInBatch();
      }
      vm.showing = true;
    });
    vm.flex = 30;

    vm.overiFrameId = -1;
  }

  function sendInBatch() {
    const batchNumber = Math.ceil(vm.allwidgets.length / vm.batchCount);
    if (batchNumber <= 1) {
      getAllReports();
    } else {
      splitWidgets();
    }
  }

  function splitWidgets() {
    vm.batchList = [];
    for (let i = 0, j = vm.allwidgets.length; i < j; i += vm.batchCount) {
      vm.batchList.push(vm.allwidgets.slice(i, i + vm.batchCount));
    }
    getBatchReports();
  }

  function getBatchReports() {
    R.forEach(
      (item) => {
        const ids = [];
        angular.forEach(item, (report) => {
          ids.push(report.widgetId);
        });
        getBatchReport(ids);
      },
      vm.batchList
    );
  }

  function getBatchReport(ids) {
    // item.showingImage = false;
    reportsDataService.getWidgetBatch(ids).then((response) => {
      if (response.status === 200) {
        angular.forEach(response.data, (item) => {
          const report = R.find(
            R.propEq(
              'widgetId',
              item.widgetId
            ),
            vm.allwidgets
          );
          if (report) {
            report.image = item.render;
            report.showingImage = true;
            report.showImageError = false;
          }
        });
      }
    }).catch(() => {
      // if (reason.status === 500) {
      //   item.showImageError = true;
      // }
    }).finally(() => {
      // item.showingImage = true;
    });
  }

  function getAllReports() {
    angular.forEach(vm.allwidgets, (item) => {
      item.showingImage = false;
      reportsDataService.getWidgetImage(item.widgetId).then((response2) => {
        if (response2.status === 200) {
          item.image = response2.data;
          item.showingImage = true;
          item.showImageError = false;
        } else {
          item.showImageError = true;
        }
      }).catch(() => {
        // if (reason.status === 500) {
        //   item.showImageError = true;
        // }
      }).finally(() => {
        item.showingImage = true;
      });
    });
  }

  function _handleShowDetailClick($event, _widget) {
    loaderService.showViewLoader = true;
    vm.imageData = null;
    vm.htmlData = null;
    reportsDataService.getWidgetImage(_widget.widgetDetailId).then((response) => {
      if (response.status === 200) {
        if (_isImage(response.data)) {
          vm.imageData = response.data;
        } else {
          vm.htmlData = response.data;
        }
        _openDashboardDetail($event, vm.imageData, vm.htmlData);
      }
    }).catch(() => {
      alerts.error('An error occurred while generating widget');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _openDashboardDetail($event, imageData, htmlData) {
    ssDialogService.dialogs.home.dashBoardDetailDialog = ssDialogService.alert(
      dashBoardDetailDialog.getOptions($event, {
        imageData,
        htmlData
      })
    );

    ssDialogService.show(ssDialogService.dialogs.home.dashBoardDetailDialog);
  }

  function _isImage(data) {
    // const type = data.split(';')[0].split('/')[1];
    let isImage = false;
    if (data) {
      const image = data.split(';')[0];
      if (image.includes('image')) {
        isImage = true;
      }
    }
    return isImage;
  }
}

DashboardSummaryController.$inject = [
  '$q',
  '$sce',
  '$rootScope',
  '$scope',
  '$timeout',
  '$http',
  'userService',
  'alerts',
  'ssDialogService',
  'dashBoardDetailDialog',
  'reportsDataService',
  'loaderService'
];
